// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CompleteWithSubtasksModal-module__modalOverlay___sG7SR {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 0, 0, 0.35);
}

.CompleteWithSubtasksModal-module__modalBackdrop___G4gQM {
  position: absolute;
  inset: 0;
  border: none;
  padding: 0;
  background: transparent;
}

.CompleteWithSubtasksModal-module__modalCard___LzrPE {
  position: relative;
  width: 100%;
  max-width: 440px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}

.CompleteWithSubtasksModal-module__modalHeader___AleIc {
  padding: 14px 16px;
  border-bottom: 1px solid #e5e7eb;
}

.CompleteWithSubtasksModal-module__modalTitle___CrMl3 {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}

.CompleteWithSubtasksModal-module__modalBody___rdBzR {
  padding: 16px;
}

.CompleteWithSubtasksModal-module__modalCopy___ZOrMv {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: #4b5563;
}

.CompleteWithSubtasksModal-module__modalCopyStrong___EqQwx {
  font-weight: 600;
  color: #111827;
}

.CompleteWithSubtasksModal-module__modalActions___XdOUk {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 16px 16px;
  border-top: 1px solid #e5e7eb;
}

.CompleteWithSubtasksModal-module__modalActionButton___P4E2l {
  min-width: 88px;
  padding: 7px 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.CompleteWithSubtasksModal-module__modalSecondaryAction___oJlP0 {
  border: 1px solid #d1d5db;
  background: #ffffff;
  color: #4b5563;
}

.CompleteWithSubtasksModal-module__modalPrimaryAction___JEAVc {
  border: none;
  background: #111827;
  color: #f9fafb;
}

.CompleteWithSubtasksModal-module__modalActionButton___P4E2l:disabled {
  cursor: default;
  opacity: 0.6;
}

@media (max-width: 640px) {
  .CompleteWithSubtasksModal-module__modalCard___LzrPE {
    max-width: 100%;
  }
  .CompleteWithSubtasksModal-module__modalActions___XdOUk {
    flex-direction: column-reverse;
  }
  .CompleteWithSubtasksModal-module__modalActionButton___P4E2l {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/CompleteWithSubtasksModal/CompleteWithSubtasksModal.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,+BAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,2CAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gCAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,uBAAA;EACA,6BAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,yBAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;AACF;;AAEA;EACE;IACE,eAAA;EACF;EAEA;IACE,8BAAA;EAAF;EAGA;IACE,WAAA;EADF;AACF","sourcesContent":[".modalOverlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  background: rgba(0, 0, 0, 0.35);\n}\n\n.modalBackdrop {\n  position: absolute;\n  inset: 0;\n  border: none;\n  padding: 0;\n  background: transparent;\n}\n\n.modalCard {\n  position: relative;\n  width: 100%;\n  max-width: 440px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.18);\n  overflow: hidden;\n}\n\n.modalHeader {\n  padding: 14px 16px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.modalTitle {\n  font-size: 16px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.modalBody {\n  padding: 16px;\n}\n\n.modalCopy {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #4b5563;\n}\n\n.modalCopyStrong {\n  font-weight: 600;\n  color: #111827;\n}\n\n.modalActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 16px 16px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.modalActionButton {\n  min-width: 88px;\n  padding: 7px 12px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.modalSecondaryAction {\n  border: 1px solid #d1d5db;\n  background: #ffffff;\n  color: #4b5563;\n}\n\n.modalPrimaryAction {\n  border: none;\n  background: #111827;\n  color: #f9fafb;\n}\n\n.modalActionButton:disabled {\n  cursor: default;\n  opacity: 0.6;\n}\n\n@media (max-width: 640px) {\n  .modalCard {\n    max-width: 100%;\n  }\n\n  .modalActions {\n    flex-direction: column-reverse;\n  }\n\n  .modalActionButton {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `CompleteWithSubtasksModal-module__modalOverlay___sG7SR`,
	"modalBackdrop": `CompleteWithSubtasksModal-module__modalBackdrop___G4gQM`,
	"modalCard": `CompleteWithSubtasksModal-module__modalCard___LzrPE`,
	"modalHeader": `CompleteWithSubtasksModal-module__modalHeader___AleIc`,
	"modalTitle": `CompleteWithSubtasksModal-module__modalTitle___CrMl3`,
	"modalBody": `CompleteWithSubtasksModal-module__modalBody___rdBzR`,
	"modalCopy": `CompleteWithSubtasksModal-module__modalCopy___ZOrMv`,
	"modalCopyStrong": `CompleteWithSubtasksModal-module__modalCopyStrong___EqQwx`,
	"modalActions": `CompleteWithSubtasksModal-module__modalActions___XdOUk`,
	"modalActionButton": `CompleteWithSubtasksModal-module__modalActionButton___P4E2l`,
	"modalSecondaryAction": `CompleteWithSubtasksModal-module__modalSecondaryAction___oJlP0`,
	"modalPrimaryAction": `CompleteWithSubtasksModal-module__modalPrimaryAction___JEAVc`
};
module.exports = ___CSS_LOADER_EXPORT___;
